import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Alert, AlertTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { resetPlanTrip, selectFormPlanTrip } from '../../../store/planTripSlice';
import './PlanTripSuccess.scss';
import { useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';
import { TripTypeChoice } from '../../../models/form-plan-trip';
 
TagManager.dataLayer({
  dataLayer: {
    event: 'planTrip',
    step: 4,
  }
});

const PlanTripSuccess = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const formPlanTrip = useSelector(selectFormPlanTrip);

  const handlePlanNewTrip = () => {
    dispatch(resetPlanTrip());
  };

  const planTripRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (planTripRef && planTripRef.current) {
      planTripRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planTripRef]);

  return (
    <Alert className="ServerSuccess PlanTripSuccess" severity="success" icon={<CheckCircleIcon />} onClose={props.onClose} ref={planTripRef} >
      <AlertTitle>{t('plan-trip.success.title')}</AlertTitle>
      { formPlanTrip.TripType === TripTypeChoice.OneWay && t('plan-trip.success.text')}
      <Button
        id='btn-plan-new-trip'
        variant="contained"
        color="success"
        size="small"
        onClick={handlePlanNewTrip}
      >
        {t('plan-trip.success.planNewTrip')}
      </Button>
    </Alert>
  );
};

export default PlanTripSuccess;